import React from 'react';
import { Router } from '@abyss/web/ui/Router';
import { config } from '@abyss/web/tools/config';
import { useGetThemePortalProps } from '@/hooks/useGetThemePortalProps';
import { createThemeOverride } from '@/style/theme';
import { PortalData, PortalName } from '@/common/DataModel/PortalData';
import { useSessionStorage } from 'usehooks-ts';
import { StoreKeys } from '@/common/constants';
import {
  EmptySSOPortalEligibilityData,
  SSOPortalEligibilityData,
} from 'api/src/dataModels/SSOPortalEligibilityData';
import { useLanguage } from '@/components/Language/LanguageProvider';
import { ThemeVersion } from '@/common/Theme/utils';
import { PortalIdentifier } from 'api/src/dataModels/PortalDataEnums';

export const PriceCare = () => {
  const { portalName, portalTheme, themeConfig } = useGetThemePortalProps();
  const themeOverride = createThemeOverride(portalTheme);
  const { locale } = useLanguage();

  const [ssoPortalEligibilityData] =
    useSessionStorage<SSOPortalEligibilityData>(
      StoreKeys.SSO_PORTAL_ELIGIBILITY_DATA,
      EmptySSOPortalEligibilityData
    );

  const { portalSource, portalIdentifier } = ssoPortalEligibilityData;

  const basePortalConfig = {
    basePath: 'costestimate',
    theme: 'uhc',
    themeOverride,
    language: locale.locale,
    loadAdobeScript: false,
    homePage: '/',
    graphQlUrl: config('PSX_GRAPHQL_API_URL'),
    mapLocationUrl: config('PSX_MAP_LOCATION_API_URL'),
    includeBaseCss: true,
    isGlobalNavEnabled: false,
  };

  const gehaThemeVersion =
    themeConfig?.[PortalIdentifier.GEHA]?.value ?? ThemeVersion.V2;

  // Conditionally add themeVersion for GEHA portal
  const portalConfig =
    portalName === PortalName.GEHA
      ? { ...basePortalConfig, themeVersion: gehaThemeVersion }
      : basePortalConfig;

  const portalData: PortalData = {
    portalName,
    portalSource,
    portalIdentifier,
    portalConfig,
    portalEligibilityData: ssoPortalEligibilityData,
  };

  return (
    <React.Fragment>
      <Router.MetaTags title="Price Care" />
      <abyss-parcel
        import="cost-estimate-sso"
        portal-data={JSON.stringify(portalData)}
      />
    </React.Fragment>
  );
};
